import { Reducer } from 'redux';
import {
  ActionTypes,
  GET_COMPARE_COMPANIES_REQUEST, GET_COMPARE_COMPANIES_SUCCESS, GET_COMPARE_COMPANIES_FAILURE,
  RESET_COMPARE_COMPANIES_STATE, GET_COMPARE_TEAMS_REQUEST, GET_COMPARE_TEAMS_SUCCESS, GET_COMPARE_TEAMS_FAILURE,
  RESET_COMPARE_TEAMS_STATE, GET_COMPARE_USERS_REQUEST, GET_COMPARE_USERS_SUCCESS, GET_COMPARE_USERS_FAILURE,
  RESET_COMPARE_USERS_STATE, GET_COMPARE_VALIDATIONS_REQUEST, GET_COMPARE_VALIDATIONS_SUCCESS, GET_COMPARE_VALIDATIONS_FAILURE,
  RESET_COMPARE_VALIDATIONS_STATE, GET_COUNT_VALIDATIONS_REQUEST, GET_COUNT_VALIDATIONS_SUCCESS, GET_COUNT_VALIDATIONS_FAILURE,
  RESET_COUNT_VALIDATIONS_STATE, GET_COUNT_LIVEUPDATE_REQUEST, GET_COUNT_LIVEUPDATE_SUCCESS, GET_COUNT_LIVEUPDATE_FAILURE,
  GET_OVERVIEW_REQUEST, GET_OVERVIEW_SUCCESS, GET_OVERVIEW_FAILURE,
  GET_AVG_REPORTING_TIME_FAILURE, GET_AVG_REPORTING_TIME_REQUEST, GET_AVG_REPORTING_TIME_SUCCESS,
  RESET_COUNT_LIVEUPDATE_STATE,
} from '../actions/dashboard.action';

export interface CompareValues {
  date1: Date;
  date2: Date;
  range: string;
  type?: string;
  privacy?: string
  companyUuid?: string;
}

export interface CountValues {
  fromDate: Date
  toDate: Date
  privacy?: string;
  companyUuid?: string
}

export interface DashboardOverviewVals {
  activeCompanyCount: number;
  activeValidations: {
    total: number,
    individualCount: number,
    legalEntityCount: number
  };
  activeUsers: number;
  activeTeams: number;
  ivValidations: {date: string; count: number}[];
  levValidations: {date: string; count: number}[];
}


export interface State {
  overview: DashboardOverviewVals;
  overviewLoading: boolean;
  overviewError: string | null;
  compareCompanies: CompareValueRes;
  compareCompaniesLoading: boolean;
  compareCompaniesError: string | null;
  compareTeams: CompareValueRes;
  compareTeamsLoading: boolean;
  compareTeamsError: string | null;
  compareUsers: CompareValueRes;
  compareUsersLoading: boolean;
  compareUsersError: string | null;
  compareValidations: CompareValueRes;
  compareValidationsLoading: boolean;
  compareValidationsError: string | null;
  countValidations: CountValueRes;
  countValidationsLoading: boolean;
  countValidationsError: string | null;
  countLiveUpdate: CountValueRes;
  countLiveUpdateLoading: boolean;
  countLiveUpdateError: string | null;
  avgReportingTime: AvgReportingTime;
  avgReportingTimeLoading: boolean;
  avgReportingTimeError: string | null;
}

export interface WeekTotal {
  daily: number[],
  weekTotal: number
}

export interface MonthTotal {
  weekly: number[],
  monthTotal: number
}

export interface YearTotal {
  monthly: number[],
  yearTotal: number
}

export interface CompareValueRes {
  total1: number | WeekTotal | MonthTotal | YearTotal;
  total2: number | WeekTotal | MonthTotal | YearTotal;
}


export interface CountValueRes {
  totalIndividualValidations: number;
  totalLegalEntityValidations: number;
  totalValidations: number;
}

export interface AvgReportingTime {
  avgUPFTime: number,
  avgApiTime: number
}

const initialState: State = {
  overview: {
    activeCompanyCount: 0,
    activeValidations: {
      total: 0,
      individualCount: 0,
      legalEntityCount: 0
    },
    activeTeams: 0,
    activeUsers: 0,
    ivValidations:[],
    levValidations: []
  },
  overviewError: null,
  overviewLoading: false,
  compareCompanies: {
    total1: 0,
    total2: 0
  },
  compareCompaniesLoading: false,
  compareCompaniesError: null,
  compareTeams: {
    total1: 0,
    total2: 0
  },
  compareTeamsLoading: false,
  compareTeamsError: null,
  compareUsers: {
    total1: 0,
    total2: 0
  },
  compareUsersLoading: false,
  compareUsersError: null,
  compareValidations: {
    total1: 0,
    total2: 0
  },
  compareValidationsLoading: false,
  compareValidationsError: null,
  countValidations: {
    totalIndividualValidations: 0,
    totalLegalEntityValidations: 0,
    totalValidations: 0,
  },
  countValidationsLoading: false,
  countValidationsError: null,
  countLiveUpdate: {
    totalIndividualValidations: 0,
    totalLegalEntityValidations: 0,
    totalValidations: 0,
  },
  countLiveUpdateLoading: false,
  countLiveUpdateError: null,

  avgReportingTime: {
    avgUPFTime: 0,
    avgApiTime: 0,
  },
  avgReportingTimeLoading: false,
  avgReportingTimeError: null,
};

const reducer: Reducer<State, ActionTypes> = (state = initialState, action) => {
  switch (action.type) {
    case GET_OVERVIEW_REQUEST:
      return { ...state, overviewLoading: true, overviewError: null };
    case GET_OVERVIEW_SUCCESS:
      return { ...state, overview: action.payload, overviewLoading: false, overviewError: null };
    case GET_OVERVIEW_FAILURE:
      return { ...state, overviewLoading: false, overviewError: action.payload };

    case GET_COMPARE_COMPANIES_REQUEST:
      return { ...state, loading: true, error: null };
    case GET_COMPARE_COMPANIES_SUCCESS:
      console.log(action.payload)
      return { ...state, compareCompanies: action.payload, loading: false, error: null };
    case GET_COMPARE_COMPANIES_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case RESET_COMPARE_COMPANIES_STATE:
      return { ...initialState }
    case GET_COMPARE_TEAMS_REQUEST:
      return { ...state, loading: true, error: null };
    case GET_COMPARE_TEAMS_SUCCESS:
      console.log(action.payload)
      return { ...state, compareTeams: action.payload, loading: false, error: null };
    case GET_COMPARE_TEAMS_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case RESET_COMPARE_TEAMS_STATE:
      return { ...initialState }
    case GET_COMPARE_USERS_REQUEST:
      return { ...state, loading: true, error: null };
    case GET_COMPARE_USERS_SUCCESS:
      console.log(action.payload)
      return { ...state, compareUsers: action.payload, loading: false, error: null };
    case GET_COMPARE_USERS_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case RESET_COMPARE_USERS_STATE:
      return { ...initialState }
    case GET_COMPARE_VALIDATIONS_REQUEST:
      return { ...state, loading: true, error: null };
    case GET_COMPARE_VALIDATIONS_SUCCESS:
      console.log(action.payload)
      return { ...state, compareValidations: action.payload, loading: false, error: null };
    case GET_COMPARE_VALIDATIONS_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case RESET_COMPARE_VALIDATIONS_STATE:
      return { ...initialState }
    case GET_COUNT_VALIDATIONS_REQUEST:
      return { ...state, loading: true, error: null };
    case GET_COUNT_VALIDATIONS_SUCCESS:
      console.log(action.payload)
      return { ...state, countValidations: action.payload, loading: false, error: null };
    case GET_COUNT_VALIDATIONS_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case RESET_COUNT_VALIDATIONS_STATE:
      return { ...initialState }
    case GET_COUNT_LIVEUPDATE_REQUEST:
      return { ...state, loading: true, error: null };
    case GET_COUNT_LIVEUPDATE_SUCCESS:
      console.log(action.payload)
      return { ...state, countLiveUpdate: action.payload, loading: false, error: null };
    case GET_COUNT_LIVEUPDATE_FAILURE:
      return { ...state, loading: false, error: action.payload };
      case GET_AVG_REPORTING_TIME_REQUEST:
        return { ...state, loading: true, error: null };
      case GET_AVG_REPORTING_TIME_SUCCESS:
        console.log(action.payload)
        return { ...state, avgReportingTime: action.payload, loading: false, error: null };
      case GET_AVG_REPORTING_TIME_FAILURE:
        return { ...state, loading: false, error: action.payload };
    case RESET_COUNT_LIVEUPDATE_STATE:
      return { ...initialState }
    default:
      return state;
  }
};

export default reducer;
